/* eslint-disable max-lines-per-function */
import React from "react";
import { Column, FormRow } from "components/common/html";
import { InputBasic, SelectState } from "components/common/form";

type FormValues = Record<string, string | number | undefined>;

type AddressGroupProps = {
  namespace?: string;
  addressLabel?: string;
  formData: FormValues;
}

export default class AddressGroup extends React.Component<AddressGroupProps> {
  render () {
    const { props } = this;
    const namespace = props.namespace ?? "";
    return (
      <div>
        <FormRow>
          <Column width={8}>
            <InputBasic
              label={props.addressLabel || "Address"}
              name={`${namespace}Address1`}
              prefix={namespace}
              formData={props.formData}
              defaultValue={props.formData[`${namespace}Address1`] as string | undefined}
            />
          </Column>

          <Column width={4}>
            <InputBasic
              label="Suite/Floor/Apt #"
              name={`${namespace}SteNumber`}
              formData={props.formData}
              defaultValue={props.formData[`${namespace}SteNumber`] as string | undefined}
            />
          </Column>
        </FormRow>
        <FormRow>
          <Column width={4}>
            <InputBasic
              label="City"
              name={`${namespace}City`}
              formData={props.formData}
              defaultValue={props.formData[`${namespace}City`] as string | undefined}
            />
          </Column>

          <Column width={4}>
            <SelectState
              label="State"
              name={`${namespace}State`}
              formData={props.formData}
              defaultValue={props.formData[`${namespace}State`] as string | undefined}
            />
          </Column>

          <Column width={4}>
            <InputBasic
              label="Zip Code"
              name={`${namespace}Zip`}
              max={5}
              formData={props.formData}
              defaultValue={props.formData[`${namespace}Zip`] as string | undefined}
            />
          </Column>
        </FormRow>
      </div>
    );
  }
}
